export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Strona"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID sklepu"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia sklepu"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Link do płatności"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywny"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nieaktywny"])}
}